import { PackageInfo } from '../UserCanister/candid/main.did';
import { NPMPackageInfo } from '../types';

/**
 * Extracts Motoko packages for the sidebar display
 */
export const getMotokoSidebarPackages = (motokoPackages: any[] | null | undefined): PackageInfo[] => {
    if (!motokoPackages || !motokoPackages[0]) return [];

    // Access the first array element since it's nested
    const packages = motokoPackages[0];

    // Map over the inner array of packages
    return packages.map((pkg: any) => ({
        name: pkg.name,
        repo: pkg.repo,
        version: pkg.version,
        dir: pkg.dir || [],
        homepage: pkg.homepage || []
    }));
};

/**
 * Extracts NPM packages for the sidebar display
 */
export const getNPMSidebarPackages = (npmPackages: any[] | null | undefined): NPMPackageInfo[] => {
    if (!npmPackages || !npmPackages[0]) return [];

    // Access the first array element since it's nested
    const packages = npmPackages[0];

    // Map over the inner array of packages
    return packages.map((pkg: any) => ({
        name: pkg.name,
        version: pkg.version,
        dependencyType: pkg.dependencyType
    }));
};

/**
 * Extracts and normalizes Motoko packages for package management
 */
export const getPackages = (motokoPackages: any[] | null | undefined): PackageInfo[] => {
    if (!motokoPackages || !motokoPackages[0]) return [];

    const packages = motokoPackages[0];

    return packages.map((pkg: any) => ({
        name: pkg.name?.trim() || "",
        repo: pkg.repo?.trim() || "",
        version: pkg.version?.trim() || "",
        dir: pkg.dir?.[0]?.length ? [pkg.dir[0]] : [],
        homepage: pkg.homepage?.[0]?.length ? [pkg.homepage[0]] : []
    }));
};